export default "__VITE_ASSET__PyOoplVP__"